<template>
  <div class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 comp-grid">
            <div class="">
              <div class="flex align-items-center">
                <div>
                  <Avatar size="large" class="primary" icon="pi pi-check-square" />
                </div>
                <div class="ml-2 mr-3">
                  <div class="text-2xl text-primary font-bold">
                    Confirmed Admissions
                  </div>
                  <div class="text-sm text-500">
                    Applicants who has accepted admission offers from your institution
                  </div>
                </div>
                <div class=""></div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="">
              <Breadcrumb :home="{
                  icon: 'pi pi-arrow-left text-lg mr-3',
                  label: 'Back',
                  command: () => {
                    $router.go(-1);
                  },
                }" :model="[
                  {
                    label: 'Confirmed Admissions',
                    to: '/applicants/confirmed_admissions',
                  },
                ]" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid justify-content-between">
          <div class="col">
            <span class="p-input-icon-left w-full">
              <i class="pi pi-search" />
              <InputText outlined dense placeholder="Search" class="w-full" v-model="searchInput" />
            </span>
          </div>
          <div class="col">
            <div class="mb-2">
              <Dropdown class="w-full" v-model="filters.applicants_country" :options="['Ghana', 'Other Nationals']"
                placeholder="Filter by Country">
              </Dropdown>
            </div>
          </div>
          <div class="col">
            <div class="mb-2">
              <div class="q-pa-sm">
                <Dropdown class="w-full" @input="
                    setFilter($menus.applicantsgenderItems, 'applicants_gender')
                  " v-model="filters.applicants_gender" optionLabel="label" optionValue="value"
                  :options="$menus.applicantsgenderItems" placeholder="Filter by Gender">
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="mb-2">
              <div class="q-pa-sm">
                <Dropdown class="w-full" @input="
                    setFilter(
                      $menus.applicantsshs_courseItems,
                      'applicants_shs_course'
                    )
                  " v-model="filters.applicants_shs_course" optionLabel="label" optionValue="value"
                  :options="$menus.applicantsshs_courseItems" placeholder="Filter by SHS Course">
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-3 col-12 comp-grid">
            <div class="">
              <div class="position-relative">
                <div class="card px-2 py-3">
                  <div class="flex align-items-center">
                    <div class="ml-2">
                      <div class="font-bold text-md">Filter by Programme</div>
                    </div>
                  </div>
                </div>
                <div class="card p-0 m-0">
                  <InputText outlined :showClear="true" dense placeholder="Search programme" class="w-full"
                    v-model="filterProgrammes" />
                </div>
                <div class="scrollbar" id="style-1">
                  <api-data-source
                    :api-path="`components_data/confirmed_admission_programme_id_list?search=${filterProgrammesValue}`"
                    v-slot="req">
                    <div v-if="req.loading" class="p-3 text-center">
                      <ProgressSpinner style="width: 30px; height: 30px" />
                    </div>
                    <Menu v-else class="w-full" :model="req.response">
                      <template #item="{ item }">
                        <router-link
                          :to="`/applicants/confirmed_admissions/institution_programme_id/${item.value}?label=${item.label}&tag=Confirmed Admissions`">
                          <Button
                            class="p-button-text text-left p-button-plain w-full flex justify-content-between align-items-center">
                            <span>{{ item.label }}</span>
                            <Badge severity="secondary" size="large" style="font-size: 0.8rem" class="px-2"
                              v-if="item.num" :value="item.num" />
                          </Button>
                        </router-link>
                      </template>
                    </Menu>
                  </api-data-source>
                </div>
              </div>
            </div>
          </div>
          <div class="md:col-9 col-12 comp-grid">
            <div class="flex align-items-center justify-content-around">
              <div v-if="searchText"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                Search
                <Chip class="font-medium px-2 py-1" removable @remove="clearSearch()">{{ searchText }}</Chip>
              </div>
              <div v-if="filters.applicants_country"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                Country
                <Chip class="font-medium px-2 py-1" removable @remove="filters.applicants_country = ''">
                  <span v-if="filtersLabel.applicants_country">{{
                    filtersLabel.applicants_country.toString()
                    }}</span>
                  <span v-else>{{ filters.applicants_country }}</span>
                </Chip>
              </div>
              <div v-if="filters.applicants_gender"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                Gender
                <Chip class="font-medium px-2 py-1" removable @remove="filters.applicants_gender = ''">
                  <span v-if="filtersLabel.applicants_gender">{{
                    filtersLabel.applicants_gender.toString()
                    }}</span>
                  <span v-else>{{ filters.applicants_gender }}</span>
                </Chip>
              </div>
              <div v-if="filters.applicants_shs_course"
                class="surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-cente">
                SHS Course
                <Chip class="font-medium px-2 py-1" removable @remove="filters.applicants_shs_course = ''">
                  <span v-if="filtersLabel.applicants_shs_course">{{
                    filtersLabel.applicants_shs_course.toString()
                    }}</span>
                  <span v-else>{{ filters.applicants_shs_course }}</span>
                </Chip>
              </div>
            </div>
            <div class="">
              <div>
                <template v-if="showBreadcrumbs && $route.query.tag">
                  <Breadcrumb :home="{
                      icon: 'pi pi-home',
                      to: '/applicants/confirmed_admissions',
                    }" :model="pageBreadCrumb" />
                </template>
                <div class="grid">
                  <!-- Master Page Start -->
                  <div class="col-12">
                    <!-- page records template -->
                    <div class="page-records">
                      <DataTable :lazy="true" :value="records" dataKey="applicant_id" @sort="onSort($event)" class=""
                        :showGridlines="false" :rowHover="true" responsiveLayout="stack">
                        <Column field="applicant_name" header="Applicant Name" :sortable="true">
                          <template #body="{ data }">
                            {{ data.applicant_name }}
                          </template>
                        </Column>
                        <Column field="country" header="Country" :sortable="true">
                          <template #body="{ data }">
                            {{ data.country }}
                          </template>
                        </Column>
                        <Column field="email_address" header="Email Address">
                          <template #body="{ data }">
                            <a class="p-button-text" :href="'mailto:' + data.email_address">{{ data.email_address }}</a>
                          </template>
                        </Column>
                        <Column field="shs_course" header="SHS Course" :sortable="true">
                          <template #body="{ data }">
                            {{ data.shs_course }}
                          </template>
                        </Column>
                        <Column headerStyle="width: 3em" headerClass="text-center">
                          <template #body="{ data }">
                            <Menubar class="p-0" ref="actionMenu" :model="getActionMenuModel(data)" />
                          </template>
                        </Column>
                      </DataTable>
                    </div>
                    <!-- page loading indicator -->
                    <template v-if="loading">
                      <div v-show="loading" class="flex align-items-center justify-content-center text-gray-500">
                        <div>
                          <ProgressSpinner style="width: 30px; height: 30px" />
                        </div>
                      </div>
                    </template>
                    <!-- end of page loading indicator-->
                    <!-- Empty record -->
                    <template v-if="!loading && !records.length">
                      <div class="p-3 my-3 text-500 text-lg font-medium text-center">
                        No record found
                      </div>
                    </template>
                    <!-- end of empty record-->
                    <!-- pagination component-->
                    <template v-if="showFooter">
                      <div class="">
                        <div v-show="!loading">
                          <div class="flex justify-content-between">
                            <div class="flex justify-content-center flex-grow-0">
                              <div class="m-2" v-if="exportButton && records.length">
                                <Button @click="
                                    (event) => $refs.exportMenu.toggle(event)
                                  " label="Export" title="Export" class="px-5 py-3 p-button-secondary"
                                  icon="pi pi-print" />
                                <Menu ref="exportMenu" popup :model="pageExportFormats" />
                              </div>
                            </div>
                            <div v-if="paginate && totalPages > 1" class="flex-grow-1">
                              <Paginator class="" @page="(event)=>{pagination.page = event.page + 1}"
                                :rows="pagination.rowsPerPage" :totalRecords="totalRecords">
                                <template #start>
                                  <span class="text-sm text-gray-500 px-2">
                                    Records <b>{{ recordsPosition }} of {{ totalRecords }}</b>
                                  </span>
                                  <span class="text-sm text-gray-500 px-2">
                                    Page <b>{{ pagination.page }} of {{ totalPages }}</b>
                                  </span>
                                </template>
                                <template #end>
                                  <Dropdown v-model="pagination.rowsPerPage" :options="[5,10,15,20,30,40,50,100,200]">
                                  </Dropdown>
                                </template>
                              </Paginator>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- end of pagination component-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import { defineAsyncComponent, ref } from "vue";
  import { utils } from "../../utils";
  import { PageMixin } from "../../mixins/page.js";
  import { ListPageMixin } from "../../mixins/listpage.js";
  import { mapActions, mapGetters, mapState } from "vuex";
  const debounce = utils.debounce;
  export default {
    name: "confirmedadmissionsApplicantsPage",
    components: {},
    mixins: [PageMixin, ListPageMixin],
    props: {
      primaryKey: {
        type: String,
        default: "applicant_id",
      },
      pageName: {
        type: String,
        default: "applicants/confirmed_admissions",
      },
      routeName: {
        type: String,
        default: "applicantsconfirmed_admissions",
      },
      apiPath: {
        type: String,
        default: "applicants/confirmed_admissions",
      },
      mergeRecords: {
        type: Boolean,
        default: false,
      },
      multiCheckbox: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        filters: {
          applicants_country: "",
          applicants_gender: "",
          applicants_shs_course: "",
        },
        filtersLabel: {},
        pageExportFormats: [
          {
            label: "Excel",
            icon: "pi pi-file-excel text-green-500",
            command: () => {
              this.exportPageRecords("excel", "xlsx");
            },
          },
        ],
        filterProgrammes: "",
        filterProgrammesValue: "",
      };
    },
    computed: {
      pageTitle: {
        get: function () {
          //set browser page title
          return "Applicants";
        },
      },
      records: {
        get: function () {
          return this.$store.getters["applicants/records"];
        },
        set: function (value) {
          this.$store.commit("applicants/setRecords", value);
        },
      },
      currentRecord: {
        get: function () {
          return this.$store.getters["applicants/currentRecord"];
        },
        set: function (value) {
          this.$store.commit("applicants/setCurrentRecord", value);
        },
      },
    },
    watch: {
      apiUrl: function () {
        this.load();
      },
      filterProgrammes: debounce(function (newVal) {
        this.filterProgrammesValue = newVal;
      }, 500),
    },
    methods: {
      ...mapActions("applicants", ["fetchRecords", "deleteRecord"]),
      getActionMenuModel(data) {
        return [
          {
            label: "Details",
            command: (event) => {
              this.openPageDrawer(
                {
                  page: "applicants/view",
                  url: `/applicants/view/${data.applicant_id}`,
                },
                { width: "40vw" }
              );
            },
            icon: "pi pi-eye",
            visible: () => this.$can.view("applicants/view"),
          },
        ];
      },
      load: function () {
        if (!this.loading) {
          this.loading = true;
          this.currentRecord = null;
          let url = this.apiUrl;
          let payload = {
            url,
            merge: this.mergeRecords,
          };
          this.fetchRecords(payload).then(
            (response) => {
              this.loading = false;
              this.ready = true;
              this.totalRecords = response.total_records;
              this.recordCount = response.record_count;
              this.pagination.rowsNumber = this.totalRecords;
              window.scrollTo(0, 0);
            },
            (response) => {
              this.loading = false;
              this.showPageRequestError(response);
            }
          );
        }
      },
    },
    async mounted() { },
    async created() { },
  };
</script>
<style scoped></style>